<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-bottom:10px;">Dedication</h1>
<p style="text-indent:0em;">Mother Nature, Father Time and the Grim Reaper all combine to interfere with the best-laid plans of mice and men and which often therefore ‘gang aglee!’ Two men, Tony Sutcliffe and Peter Done stood by me when what seemed like the whole world was against me. For five years, I suffered the tortures of the dammed (plus serious ill health!) while the legal process dragged on and on, but these two stood by me, supported me even when the evidence seemed entirely against me and, when the evidence of the other side justifiably fell apart, saw that their faith in me had been justified.</p>
<p style="text-indent:0em;">One of them is, alas, no longer with us but I hope he will be able to read the heavenly edition (top of the 100 best reads when cloud resting) and receive my thanks. To the other one, Peter, don’t you dare catch the Heavenly Express, Platform 131/2, Piccadilly, before I can thank you – thank you. Because those three troublemakers mentioned above could interfere and leave neither around to read it (I hope they don’t! They’ve already done so with Tony). I have had to place this dedication at the start of Book 2, instead of 3, where it more properly belongs. For the full details, my reader, you will have to wait ’til Book 3 when all will become clear.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?343e9ffa